import './index.css';
import { jsx } from 'react/jsx-runtime';
import { forwardRef, useState, useRef, useCallback, useEffect } from 'react';
import { useMultipleRefs } from '@hh.ru/magritte-common-use-multiple-refs';
import { Tooltip } from './Tooltip.js';
import 'classnames';
import '@hh.ru/magritte-internal-drop-base';
import '@hh.ru/magritte-ui-action';
import '@hh.ru/magritte-ui-breakpoint';
import '@hh.ru/magritte-ui-button';
import '@hh.ru/magritte-ui-icon/icon';
import '@hh.ru/magritte-ui-layer';
import './TooltipArrow.js';
import '@hh.ru/magritte-ui-typography';
import '@hh.ru/magritte-ui-typography/BaseText';

const TooltipHover = forwardRef(({ activatorRef, children, ignoreIntersections = true, size = 'medium', ...props }, ref) => {
    const [visible, setVisible] = useState(false);
    const isSmallRef = useRef(false);
    const hideTimerRef = useRef(null);
    isSmallRef.current = size === 'small';
    const toggleVisible = useCallback((visible) => {
        if (visible === true) {
            if (hideTimerRef.current) {
                clearTimeout(hideTimerRef.current);
                hideTimerRef.current = null;
            }
            setVisible(true);
            return;
        }
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        isSmallRef.current
            ? setVisible(false)
            : (hideTimerRef.current = setTimeout(() => setVisible(false), 100));
    }, [setVisible]);
    const tooltipRefCallback = useCallback((node) => {
        if (node && !isSmallRef.current) {
            node.addEventListener('mouseenter', () => toggleVisible(true));
            node.addEventListener('mouseleave', () => toggleVisible(false));
        }
    }, [toggleVisible]);
    const tooltipRefMulti = useMultipleRefs(tooltipRefCallback, ref);
    useEffect(() => {
        const activator = activatorRef.current;
        if (!activator) {
            return void 0;
        }
        let isTouchEnabled = false;
        const handleTouchStart = () => (isTouchEnabled = true);
        const handleMouseEnter = () => !isTouchEnabled && toggleVisible(true);
        const handleMouseLeave = () => toggleVisible(false);
        activator.addEventListener('touchstart', handleTouchStart);
        activator.addEventListener('mouseenter', handleMouseEnter);
        activator.addEventListener('mouseleave', handleMouseLeave);
        return () => {
            activator.removeEventListener('touchstart', handleTouchStart);
            activator.removeEventListener('mouseenter', handleMouseEnter);
            activator.removeEventListener('mouseleave', handleMouseLeave);
        };
    }, [activatorRef, toggleVisible]);
    return (jsx(Tooltip, { ...props, size: size, onClose: () => setVisible(false), ignoreIntersections: ignoreIntersections, visible: visible, activatorRef: activatorRef, ref: tooltipRefMulti, children: children }));
});
TooltipHover.displayName = 'TooltipHover';

export { TooltipHover };
//# sourceMappingURL=TooltipHover.js.map
